import { Tooltip, type TooltipProps } from "recharts";

/** The same surface and type treatment for every Recharts tooltip. */
export function ChartTooltip(props: TooltipProps) {
  return (
    <Tooltip
      {...props}
      contentStyle={{
        background: "var(--color-surface)",
        border: "1px solid var(--color-input)",
        borderRadius: 7,
        color: "var(--color-ink)",
        fontSize: 12,
      }}
      labelStyle={{ color: "var(--color-ink)", fontWeight: 600 }}
      itemStyle={{ color: "var(--color-body)" }}
    />
  );
}
